import classNames from 'classnames'
import { createElement, forwardRef, PropsWithChildren } from 'react'
import { sprinkles, Sprinkles } from '../../theme/sprinkles.css'
import { AsComponentProp, NativeProps } from '../types'

// Exclude some of the props that Box component does not use
type ComponentProps = Omit<
	Sprinkles,
	| 'justifyContent'
	| 'flexDirection'
	| 'alignItems'
	| 'flexWrap'
	| 'gap'
	| 'justifySelf'
	| 'alignSelf'
	| 'flexGrow'
	| 'flexShrink'
	| 'order'
	| 'wrap'
	| 'shrink'
>
type Props = PropsWithChildren<NativeProps & AsComponentProp & ComponentProps>

export const Box = forwardRef<HTMLElement, Props>(({ component = 'div', className, ...rest }, ref) => {
	const sprinklesProps: Record<string, unknown> = {}
	const nativeProps: Record<string, unknown> = {}

	for (const key in rest) {
		if (sprinkles.properties.has(key as keyof Sprinkles)) {
			sprinklesProps[key] = rest[key as keyof typeof rest]
		} else {
			nativeProps[key] = rest[key as keyof typeof rest]
		}
	}

	return createElement(component, { ref, className: classNames(sprinkles(sprinklesProps), className), ...nativeProps })
})
